export const enum ActiveSelectionPropertiesEnum {
  Categories = "categories",
  SectionName = "sectionName",
  DisplayedSectionName = "displayedSectionName",
  SeatLabeling = "seatLabeling",
  Reverse = "reverse",
  StarstAt = "startsAt",
  RowLabel = "rowLabel",
  RowTableStartsAt = "rowTableStartsAt",
  LabelPositionLeft = "labelPositionLeft",
  LabelPositionRight = "labelPositionRight",
  TableLabel = "tableLabel",
  SeatsLeft = "seatsLeft",
  SeatsRight = "seatsRight",
  SeatsUp = "seatsUp",
  SeatsDown = "seatsDown",
  RoundTableSeatsQuantity = "roundTableSeatsQuantity",
  RowSeatsQuantity = "rowSeatsQuantity",
  RowCurve= "rowCurve",
  RowSeatSpacing = "rowSeatSpacing",
  RowSpacing = "rowSpacing",
  TableSelectionType = "tableSelectionType",
  TableRadius = "tableRadius",
  TableWidth = "tableWidth",
  TableHeight = "tableHeigth",
  RoundTableEmptySpaces = "roundTableEmptySpaces"
}
